import Vue from 'vue'
import Vuex from 'vuex'
import user_module from "@/store/modules/user_module";
import payment_requests from "@/store/modules/payment_requests_module";
import timeModule from "@/store/modules/time-module";
import VuexPersistence from "vuex-persist";
import { set, get, del } from "idb-keyval";
import axios from "axios";
import {Storage} from "@/Services/Storage";

Vue.use(Vuex)

const getInitialRootState = () => ({
    isHydrated : false,
    loading: false,
    currentUser : null,
    isUpdateAvailable : false,
    selectedWallet : null,
});

// IndexedDB Storage Handler
const indexedDBStorage = {
    async getItem(key) {
        const value = await get(key);
        console.log("Getting from IndexedDB:", { key, value });
        return value || null;
    },
    async setItem(key, value) {
        console.log("Saving to IndexedDB:", { key, value });
        await set(key, value);
    },
    async removeItem(key) {
        console.log("Removing from IndexedDB:", key);
        await del(key);
    },
};

//  VuexPersistence Configuration
const vuexLocal = new VuexPersistence({
    storage: indexedDBStorage, // Use IndexedDB instead of localStorage
    asyncStorage: true, // Enable async storage handling
    restoreState: async (key) => {
        try {
            const value = await get(key);
            console.log("Restoring state from IndexedDB:", { key, value });
            const baseState = { ...getInitialRootState(), isHydrated: true };
            if (value) {
                return { ...baseState, ...value, loading: false, isHydrated: true };
            }
            return baseState;
        } catch (err) {
            console.error("Error restoring state:", err);
            return { ...getInitialRootState(), isHydrated: true };
        }
    },
    saveState: async (key, value) => {
        try {
            const cleanState = cleanUpState(value);
            // console.log('Saving state to IndexedDB:', { key, value });
            await set(key, cleanState);
        } catch (err) {
            console.error("Error saving state:", err);
        }
    },
});
function cleanUpState(state) {
    const clonedState = JSON.parse(JSON.stringify(state));
    delete clonedState.loading;
    delete clonedState.isHydrated;
    return clonedState;
}

export default new Vuex.Store({
    state: getInitialRootState(),
    getters: {
        isHydrated: (state) => state.isHydrated,
        getUpdateAvailability : (state) => state.isUpdateAvailable,
        getLoadingState: (state) => state.loading,
        getSelectedWallet: (state) => state.selectedWallet,
    },
    mutations: {
        setUpdateAvailability : (state , payload) => state.isUpdateAvailable = payload,
        setLoadingState: (state, payload) => state.loading = payload,
        setSelectedWallet: (state, payload) => state.selectedWallet = payload,
        setUser(state, user) {
            state.user = user;
        },
        clearUserData(state) {
            state.user = null;
        }

    },
    actions: {
    },
    modules: {
        user_module, timeModule, payment_requests,
    },
    plugins: [vuexLocal.plugin],
});
